<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局分页居中对齐 */
.el-pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
</style>
